const ErrorCard = (props) => {
    return (
        <div className="card-error">
            {props.errors.map((error) => <p key={error}>{error}</p>)}
        </div>
    )
};

export default ErrorCard;